// extracted by mini-css-extract-plugin
export default {"voidHeader":"testmap_voidHeader__XQgvq","mapDiv":"testmap_mapDiv__KM3s7","map":"testmap_map__j6mNH","onlyPC":"testmap_onlyPC__JMNT0","onlymobile":"testmap_onlymobile__5Lr3N"};